export enum RouteName {
    Root = 'root',
    Login = 'login',
    OrganizationsList = 'organizations-list',
    OrganizationDetails = 'organization-details',
    OrganizationDetailsMembers = 'organization-details-members',
    OrganizationDetailsDataSets = 'organization-details-data-sets',
    OrganizationDetailsWOManufacturerMatches = 'organization-details-wo-manufacturer-matches',
    OrganizationDetailsWOModelMatches = 'organization-details-wo-model-matches',
    OrganizationDetailsWOModelManufacturerMatches = 'organization-details-wo-model-manufacturer-matches',
    OrganizationDetailsWOModelManufacturerMatchesStart = 'organization-details-wo-model-manufacturer-matches-start',
    OrganizationDetailsWOManufacturerMatchWizard = 'organization-details-wo-manufacturer-match-wizard',
    OrganizationDetailsWOModelMatchWizard = 'organization-details-wo-model-match-wizard',
    OrganizationDetailsQueueTasks = 'organization-details-queue-tasks',
    OrganizationDetailsInvitationCodes = 'organization-details-invitation-codes',
    OrganizationDetailsProfile = 'organization-details-profile',
    OrganizationDetailsDomains = 'organization-details-domains',
    OrganizationDetailsGrants = 'organization-details-grants',
    OrganizationDetailsFeatureFlags = 'organization-details-feature-flags',
    OrganizationDetailsViPrompt = 'organization-details-vi-prompt',
    UsersList = 'users-list',
    UserDetails = 'user-details',
    DataSets = 'data-sets',
    DataSetDetails = 'data-set-details',
    DataSetDetailsDocuments = 'data-set-details-documents',
    DataSetDetailsQuestions = 'data-set-details-questions',
    DataSetDetailsTestRuns = 'data-set-details-test-runs',
    Manufacturers = 'manufacturers',
    Models = 'models',
    Documents = 'documents',
    DocumentDetails = 'document-details',
    DocumentDetailsInfo = 'document-details-info',
    DocumentDetailsQuestions = 'document-details-questions',
    DocumentDetailsTestRuns = 'document-details-test-runs',
    DocumentDetailsVersions = 'document-details-versions',
    DocumentDetailsQueueTasks = 'document-details-queue-tasks',
    DocumentTestRunDetails = 'document-test-run-details',
    Prompts = 'prompts',
    AgentPromptDetails = 'agent-prompt-details',
    AgentPromptNew = 'agent-prompt-new',
    TestRuns = 'test-runs',
    KnowledgeArticles = 'knowledge-articles',
    QueueTasks = 'queue-tasks',
    WorkOrders = 'work-orders',
}
